import { Box, Button, Container, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const ContactUs: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Box bg="brand.black" color="white" mt={{ base: '350px', md: 36 }} py={4}>
      <Container maxW="8xl" px={{ base: 0 }} py={16}>
        <Flex
          alignItems="center"
          direction={{ base: 'column', lg: 'row' }}
          gap={8}
          justifyContent="space-between"
          position="relative"
          w="full"
        >
          <Container
            m={0}
            maxWidth={{ base: 'full', lg: 500, xl: 600 }}
            pt={{ base: 32, lg: 0 }}
            textAlign={{ base: 'center', lg: 'left' }}
          >
            <Heading as="h1" fontSize={{ base: 'h1.base', md: 'h1.md' }} pb={8}>
              {t('LANDING.CONTACT_US.TITLE')}
            </Heading>
            <Text as="h2" fontSize={{ base: 'h2.base', md: 'h2.md' }} pb={8}>
              {t('LANDING.CONTACT_US.CONTENT')}
            </Text>
            <Button
              as="a"
              href="https://www.mbecorporate.com/contact-us/"
              variant="mbeSecondaryDark"
            >
              {t('LANDING.CONTACT_US.CTA')}
            </Button>
          </Container>

          <Image
            bg="gray.200"
            h={{ base: 350, lg: 500 }}
            position="absolute"
            right={{ lg: '24px' }}
            src="/images/contact.webp"
            srcSet="/images/contact@2x.webp 2x, /images/contact@3x.webp 3x"
            top={{ base: '-350px', md: '-250px' }}
            w={{ base: 350, lg: 500 }}
          />
        </Flex>
      </Container>
    </Box>
  );
};
